module.exports = __webpack_public_path__ + "img/addtojob.13dd48e4.svg";